import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import { showMessage } from "../../messages/messagesActions";
import { ITestOne } from "./testOne.types";

function generateAdvanceFilterQuery(data: any) {
  const filters = [];

  for (const [key, value] of Object.entries(data)) {
	if (value !== "" && value !== null) {
	  let filterObj = {
		column: [key],
		operator: "EQUAL",
		value: value,
		logicalOperator: "AND"
	  };
	  if(key === "transaction_date"){
		filterObj = {
		  column: [key],
		  operator: "CONTAINS",
		  value: value+"-",
		  logicalOperator: "AND"
		};
	  }
	  if(key === "user_fact_id"){
		const filterObj = {
		  column: ["producer_one_id", "producer_two_id", "producer_three_id"],
		  operator: "EQUAL",
		  value: value,
		  logicalOperator: "AND"
		};
	
		const encodedFilter = encodeURIComponent(JSON.stringify(filterObj, null, 2));
		filters.push(`advanceFilter=${encodedFilter}`);
	  }else {
		const encodedFilter = encodeURIComponent(JSON.stringify(filterObj, null, 2));
		filters.push(`advanceFilter=${encodedFilter}`);
	  }
  

	 
	}
  }

  return filters.join("&");
}

export const FETCH_TEST_ONE_LIST_PROGRESS = "FETCH_TEST_ONE_LIST_PROGRESS";
export const FETCH_TEST_ONE_LIST_SUCCESS = "FETCH_TEST_ONE_LIST_SUCCESS";
export const FETCH_TEST_ONE_LIST_FAILURE = "FETCH_TEST_ONE_LIST_FAILURE";

export const fetchTestOneListProgress = () =>
  action(FETCH_TEST_ONE_LIST_PROGRESS);
export const fetchTestOneListSuccess = (list: ITestOne[]) =>
  action(FETCH_TEST_ONE_LIST_SUCCESS, { list });
export const fetchTestOneListFailure = () =>
  action(FETCH_TEST_ONE_LIST_FAILURE);

export const fetchTestOneListAsync =
  (searchState: {[key: string]: any}): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
	try {
	  dispatch(fetchTestOneListProgress());
	  const query = generateAdvanceFilterQuery(searchState);
	  let finalUrl = `/customer/get-customer-statement`;
	  if(query){
		finalUrl+= "?"+query
	  }

	  const res = await api.get(finalUrl);
	  const data = res.data.data;
	 dispatch(fetchTestOneListSuccess(data));
	} catch (err: any) {
	  dispatch(fetchTestOneListFailure());
	  dispatch(
		showMessage({
		  type: "error",
		  message: err.response.data.message,
		  displayAs: "snackbar",
		})
	  );
	}
  };

export const CLEAR_TEST_ONE_STATE = "CLEAR_TEST_ONE_STATE";
export const clearTestOneState = () => action(CLEAR_TEST_ONE_STATE);
